<template>
    <div class="timelineView">
        <Header/>
        <Announcement/>
        <Timeline/>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Announcement from '@/components/Announcement.vue'
    import Timeline from '@/components/timeline/Timeline.vue'

    export default {
      name: 'TimelineView',
      components: {
        Header,
        Announcement,
        Timeline
      }
    }
</script>
